<template>
  <div class="account-management">
    <div class="d-flex justify-content-between align-items-center title">
      <span class="title-left">Tùy chọn tài khoản liên kết</span>
      <div class="d-flex title-right align-items-center">
        <span class=" pr-2">Số tài khoản trong gói: <span
            class="title-number">{{
            globalData.logged_in_user.shopLimit
          }} </span></span>
        <span class="d-flex title-hotline align-items-center px-2"> Hotline: <span
            class="title-number"> 1900 633 841 </span></span>
      </div>
    </div>
    <div class="d-flex content">
      <div class="content-left w-50 px-2">
        <div class="accordion" role="tablist">
          <b-card no-body class="mb-1" v-for="(channel) in globalData.channel" :key="channel.name">
            <div class="d-flex align-items-center channel" @click="openAccordion(channel.name)">
              <img class="option_image" height="20px" width="20px" :src="'/icons/logo/'+channel.icon">
              <span class="channel-name pl-1">{{ channel.name }} ({{ numPage(channel.name) }})
              <span class="limit-channel pl-3"
                    v-if="channel.name === globalData.channel.TIKTOK.name && (globalData.logged_in_user.tiktokShopLimit || globalData.logged_in_user.tiktokShopLimit === 0 )"> Giới hạn số tài khoản là: {{ globalData.logged_in_user.tiktokShopLimit }} </span>
            </span>
            </div>
            <b-collapse :id='channel.name' accordion="my-accordion" role="tabpanel">
              <div class=" list-channel scrollbar scrollbar-hidden">
                <div v-for="(page) in globalData.initData.pages.filter(page => page._id.channel === channel.name)"
                     :key="page._id.account_id">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" :value="page" :id="page._id.account_id"
                           v-model="list_select_page" :disabled=" !isChecked(page) && checkMaxSelection(page)">
                    <label class="form-check-label" :for="page._id.account_id">
                      {{ page.name }}
                    </label>
                  </div>
                </div>
              </div>
            </b-collapse>
          </b-card>
        </div>
      </div>
      <div class="content-right w-50 px-2">
        <div class="d-flex justify-content-between align-items-center">
          <span class="content-right-title">Tài khoản đã chọn ({{ list_select_page.length }})</span>
          <div class="icon-icon-trash" @click="clearSelectPage"></div>
        </div>
        <div class="list-select-channel scrollbar-hidden scrollbar">
          <div v-for="(page) in list_select_page" :key="page._id.account_id" class="py-1">
            <div class="page-select d-flex justify-content-between px-1">
              <div class="px-1 d-flex align-items-center ">
                <div>
                  <img class="option_image" height="20px" width="20px" :src="'/icons/logo/'+page._id.channel+'.svg'">
                  <span class="page-select-name pl-1">{{ page.name }}</span>
                </div>
              </div>
              <b-icon-x @click="deletePage(page)"></b-icon-x>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="text-right mt-2 pr-2">
        <b-button @click="deactivatedAccount" variant="primary" :disabled="handlerComplete()">Hoàn thành</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/lib/callAPI";

export default {
  name: "AccountManagementModal",
  data() {
    return {
      select_channel: '',
      list_select_page: [],
    }
  },
  created() {
  },
  methods: {
    handlerComplete(){
      if(this.globalData.logged_in_user.tiktokShopLimit === 0 && this.list_select_page.filter(page => page._id.channel !== this.globalData.channel.TIKTOK.name).length === 0 ){
        return true
      }
      return this.list_select_page.length === 0
    },
    openAccordion(channel) {
      this.select_channel = channel
      this.$root.$emit('bv::toggle::collapse', channel)
    },
    numPage(channel) {
      return this.list_select_page.filter(page => page._id.channel === channel).length
    },
    clearSelectPage() {
      this.list_select_page = []
    },
    deletePage(page){
      this.list_select_page = this.list_select_page.filter(p => p._id.account_id !== page._id.account_id )
    },
    isChecked(page) {
      return this.list_select_page.includes(page);
    },
    checkMaxSelection(page) {
      if(page._id.channel === this.globalData.channel.TIKTOK.name){
        if(this.globalData.logged_in_user.tiktokShopLimit || this.globalData.logged_in_user.tiktokShopLimit === 0){
          return this.list_select_page.filter(page => page._id.channel === this.globalData.channel.TIKTOK.name).length >= this.globalData.logged_in_user.tiktokShopLimit || this.list_select_page.length >= this.globalData.logged_in_user.shopLimit
        }else {
          return this.list_select_page.length >= this.globalData.logged_in_user.shopLimit
        }
      }else {
        return this.list_select_page.length >= this.globalData.logged_in_user.shopLimit
      }
    },
    async deactivatedAccount(){
      let list_account_id_select_page = this.list_select_page.map(page => page._id.account_id)
      const list_delete_account_ids = this.globalData.initData.pages.filter(page => !list_account_id_select_page.includes(page._id.account_id)).map(page => page._id)
      let request = {
        account_ids: list_delete_account_ids
      };
      await api.post('/api/connection/deactivatedAccount', request).then(result => {
        if (result.success) {
          this.globalData.initData.pages = result.data;
          this.$emit('close');
          return this.$bvToast.toast("Lưu thành công", {variant: 'success', solid: true, noCloseButton: true})
        } else {
          return this.$bvToast.toast(result.message, {variant: 'danger', solid: true, noCloseButton: true})
        }
      });
    }
  }
}
</script>

<style scoped>
.page-select-name {
  font-size: 14px;
  font-weight: 400;
  line-height: 28px;
  color: #7A7F83;
}

.page-select {
  display: flex;
  align-items: center;
  height: 36px;
  border: 1px #ECECEC solid;
  border-radius: 4px;
}

.list-select-channel {
  max-height: 410px;
  overflow-y: scroll;
}


.content-right-title {
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
}

.content-right {
  padding: 0px 16px;
}


.content-left {
  padding: 0px 16px;
}

.list-channel {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 12px;
  max-height: 232px;
  overflow-y: scroll;
}

.limit-channel {
  color: #7A7F83;
  font-size: 13px;
  font-weight: 400;
}

.channel-name {
  font-size: 16px;
  line-height: 28px;
  font-weight: 600;
}

.channel {
  height: 36px;
  background-color: #F4F5F9;
  padding: 4px 8px 4px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.content {
  height: 480px;
  padding: 16px 16px;
}

.title-hotline {
  height: 40px;
  border: 1px #CED2D6 solid;
  border-radius: 4px;
}

.title-number {
  color: #327AE7;
}

.title-right {
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
}

.title-left {
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
}

.account-management {
  background-color: white;
  height: 608px;
  width: 680px;
}

.title {
  padding: 0px 16px;
  height: 64px;
}
</style>